import { Form, Input, Modal, Spin, Switch } from "antd";
import { FC } from "react";

export interface CreationModalProps {
  loading: boolean;
  visible: boolean;
  onOk: (values: FAQCreationForm) => void;
  onCancel: () => void;
}

export interface FAQCreationForm {
  title: string;
  isActive: boolean;
}

const CreationModal: FC<CreationModalProps> = ({
  loading,
  visible,
  onOk,
  onCancel,
}: CreationModalProps) => {
  const [form] = Form.useForm<FAQCreationForm>();

  const handleFormSubmit = (values: FAQCreationForm) => {
    onOk(values);
  };

  return (
    <Modal
      title="Add a new FAQ"
      visible={visible}
      onOk={() => {
        form.submit();
      }}
      onCancel={() => {
        onCancel();
      }}
      confirmLoading={loading}
      cancelButtonProps={{
        loading,
      }}
      afterClose={() => {
        form.resetFields();
      }}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          onFinish={handleFormSubmit}
          layout="vertical"
          validateMessages={{
            // eslint-disable-next-line no-template-curly-in-string
            required: "${label} is required!",
          }}
        >
          <Form.Item name="title" label="Title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="isActive"
            label="Active"
            valuePropName="checked"
            initialValue={false}
          >
            <Switch />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default CreationModal;
